import { theme as AntTheme, type ThemeConfig } from 'antd';
import { useSistemaQuery } from '@/features/sistema/api';
import { useLayoutStore } from '../store';

const LIGHT_THEME: ThemeConfig = {
    algorithm: AntTheme.defaultAlgorithm,
    components: {
        Layout: {
            siderBg: '#fff',
            triggerBg: '#fff',
            triggerColor: '#000',
        },
        Menu: {
            subMenuItemBg: '#e4e9f0',
        },
        Table: {
            headerBg: '#f0f2f4',
        },
    },
};

const DARK_THEME: ThemeConfig = {
    algorithm: AntTheme.darkAlgorithm,
    components: {
        Layout: {
            siderBg: '#001628',
            triggerBg: '#001628',
            triggerColor: '#fff',
        },
        Menu: {
            subMenuItemBg: '#001628',
        },
    },
};

export function useTheme(): ThemeConfig {
    const theme = useLayoutStore((s) => s.theme);
    const selectedTheme = theme === 'light' ? LIGHT_THEME : DARK_THEME;

    const { sistema } = useSistemaQuery();

    return {
        ...selectedTheme,
        components: {
            ...selectedTheme.components,
            Breadcrumb: {
                colorText: sistema?.layout.sic_menu_titulo ?? undefined,
            },
            Button: {
                colorTextLightSolid: sistema?.layout.sic_botao_texto ?? undefined,
            },
            Splitter: {
                splitBarSize: 4,
            },
            Switch: {
                colorTextLightSolid: sistema?.layout.sic_botao_texto ?? undefined,
            },
        },
        token: {
            ...selectedTheme.token,
            colorPrimary: sistema?.layout.sic_cor_primaria,
            fontFamily: 'mukta',
        },
        zeroRuntime: true,
    };
}
